<template>
  <div class="form-outline pa-3">
    <form-legend :field="field" />
    <v-radio-group
      v-model="fieldValue"
      column
      :rules="getFieldRules({ required: field.required })"
      :hint="field.field_options.description"
      persistent-hint
      v-bind="darkOrLightMode"

    >
<!--      <template v-slot:label>-->
<!--        <form-legend :field="field" />-->
<!--      </template>-->
      <v-radio
        v-for="(radio, key) in field.field_options.options"
        :key="'radio-' + key"
        :label="radio.label"
        :value="radio.label"
        color="primary-action"
        :readonly="readonly"
        class="my-2"
      />
      <div v-if="hasOtherOption" style="display: flex">
        <v-radio class="pt-2" :key="'radio-Anderes' + field.cid" :label="$t('other')" value="Anderes"  :readonly="readonly" />
        <v-text-field
          v-if="otherOptionIsSelected"
          v-model="otherValue"
          :rules="getFieldRules({ required: hasOtherOption })"
          :readonly="readonly"
          class="ml-4"
          autofocus
          clearable
          color="primary-action"
        />
      </div>
<!--      <template v-slot:message="{ message }">-->
<!--        <legend v-html="message" />-->
<!--      </template>-->
    </v-radio-group>
  </div>
</template>

<script>
import formsMixin from '../formsMixin';
import FormLegend from '@/modules/forms/FormLegend.vue';

export default {
  components: { FormLegend },
  mixins: [formsMixin],
  emits: ['formUpdated'],
  props: {
    field: { type: Object, required: true },
    formModel: { type: Object, required: true },
    mediasModel: { type: Array, required: true },
    readonly: { type: Boolean, default: false },
    mode: { type: String, default: 'light' },
  },
  data() {
    return {
      fieldValue: this.formModel[this.field.cid] ? this.formModel[this.field.cid] : '',
      otherValue: this.formModel[this.field.cid + '_anderes'] ? this.formModel[this.field.cid + '_anderes'] : '',
    };
  },
  computed: {
    hasOtherOption() {
      return this.fieldOptions.include_other_option;
    },
    otherOptionIsSelected() {
      return this.fieldValue === 'Anderes';
    },
    fieldOptions() {
      return this.field && this.field.field_options ? this.field.field_options : null;
    },
    rules() {
      return [this.validateOtherField(), this.validateRequired()];
    },
  },
  methods: {
    validateOtherField() {
      if (this.hasOtherOption && this.otherOptionIsSelected) {
        const field = this.formModel[this.field.cid + '_anderes'];
        return (field && field.length > 0) || this.$t('field.required');
      }
      return true;
    },
    validateRequired() {
      if (this.field.required) {
        const field = this.formModel[this.field.cid];
        return (field && field.length > 0) || this.$t('field.required');
      } else {
        return true;
      }
    },
  },
  watch: {
    fieldValue(newValue) {
      this.$emit('formUpdated', this.field.cid, newValue);
      if (!this.otherOptionIsSelected) {
        this.otherValue = '';
      }
    },
    otherValue(newValue) {
      this.$emit('formUpdated', this.field.cid + '_anderes', newValue);
    },
    formModel(newValue) {
      const value = newValue[this.field.cid] ? newValue[this.field.cid] : '';
      if (this.fieldValue !== value) {
        this.fieldValue = value;
      }
    },
  },
};
</script>
